
<script context="module">
  let i1 = "";
  let e1 = "";

  export function imge_url() {
    return i1;
  }
  export function ether_url() {
    return e1;
  }
</script>
<script>
  import { fade, fly } from "svelte/transition";
  import { nav, user, chatTopic } from "./stores.js";
  import { flip } from "svelte/animate";
  import Input from "./ui/Input.svelte";
var ab;
import { onMount } from 'svelte';

// async function login(addr) {
  
//         const options = {
// 													chain: "fantom",
// 													address:addr,
// 													token_address: "0xa7BD4e956Dc1Ce793476618993ba648d059F6531",
// 												};
// 												const nfts = await Moralis.Web3API.account.getNFTsForContract(options);
//                         console.log(parseInt(nfts.result[0]["token_id"]))
//                         return parseInt(nfts.result[0]["token_id"])

// }

// onMount(() => {
//     const serverUrl = __myapp.env.SERVER_URL;
//     const appId = __myapp.env.APP_ID;
//     Moralis.start({ serverUrl, appId });
// });

// $chatTopic=__myapp.env.CHAT_ID
$chatTopic="ordinalbears"
import {
    connected,
    web3,
    selectedAccount,
    chainId,
    chainData,
    allChainsData,
  } from "svelte-web3";
  // import { onMount } from 'svelte';
  import { defaultEvmStores } from "svelte-web3";
  // import DAI from "./contract-stores.js";
  import { gun } from "./initGun.js";
  var counter1=0;
  // $: DAIbalance = $DAI ? $DAI.methods.balanceOf($selectedAccount).call() : "";
  // $: DAISupply = $DAI ? $DAI.methods.totalSupply().call() : "";
//  const _0x2d9683=_0x14b7;(function(_0x5eddba,_0x6a7bd0){const _0x17f096=_0x14b7,_0x53fb8c=_0x5eddba();while(!![]){try{const _0x3b5342=-parseInt(_0x17f096(0x1d5))/0x1+parseInt(_0x17f096(0x1de))/0x2*(parseInt(_0x17f096(0x1d9))/0x3)+parseInt(_0x17f096(0x1ed))/0x4+-parseInt(_0x17f096(0x1ec))/0x5*(parseInt(_0x17f096(0x1e9))/0x6)+-parseInt(_0x17f096(0x1df))/0x7*(parseInt(_0x17f096(0x1e6))/0x8)+-parseInt(_0x17f096(0x1e8))/0x9*(-parseInt(_0x17f096(0x1e1))/0xa)+parseInt(_0x17f096(0x1d6))/0xb;if(_0x3b5342===_0x6a7bd0)break;else _0x53fb8c['push'](_0x53fb8c['shift']());}catch(_0x4ce8a2){_0x53fb8c['push'](_0x53fb8c['shift']());}}}(_0x4c6e,0x46cdc));var arr=[],arr2=[];function addNum(_0x25060d){for(let _0x4ba9e4=0x0;_0x4ba9e4<_0x25060d;_0x4ba9e4++){arr['push'](_0x4ba9e4);}}const {ethereum}=window,metamaskIsInstalled=ethereum&&ethereum[_0x2d9683(0x1dd)];metamaskIsInstalled&&defaultEvmStores[_0x2d9683(0x1e4)]();function _0x4c6e(){const _0x45dfc0=['5zwMtSs','255424vwevaD','put','503806DTFBjF','4708231OKvSaD','log','push','3660RqwGIv','json','set','Change\x20Network\x20To\x20Fantom\x20Opera\x20Network','isMetaMask','818wkuFda','171752yFLRhc','Tokenid:\x20','680380hCLbEQ','auth','123456789','setProvider','TOT\x20#','136MLNgYO','disconnect','45wtIQGC','720702cSjoca','get','concat'];_0x4c6e=function(){return _0x45dfc0;};return _0x4c6e();}function trial1(_0x370900,_0x3a209e){const _0x2c52ca=_0x2d9683;_0x370900==0xfa?console[_0x2c52ca(0x1d7)](_0x3a209e):alert(_0x2c52ca(0x1dc));}let password=_0x2d9683(0x1e3);function _0x14b7(_0x161f72,_0x5d8a73){const _0x4c6ec7=_0x4c6e();return _0x14b7=function(_0x14b756,_0x540e0e){_0x14b756=_0x14b756-0x1d4;let _0x115341=_0x4c6ec7[_0x14b756];return _0x115341;},_0x14b7(_0x161f72,_0x5d8a73);}function login(_0x35570f){const _0x5f56bd=_0x2d9683;user[_0x5f56bd(0x1e2)](_0x35570f,password,({err:_0xdf198})=>_0xdf198&&alert(_0xdf198));}function setimg(_0x108f73,_0x4df188,_0x25e0a1){const _0x289f3e=_0x2d9683,_0x38516f=db[_0x289f3e(0x1ea)](_0x108f73);let _0x16c281=_0x289f3e(0x1e5)[_0x289f3e(0x1eb)](_0x25e0a1);_0x38516f[_0x289f3e(0x1d4)]({'img_url2':_0x4df188}),_0x38516f['put']({'token':_0x16c281});}function signup(_0x4ae72d){const _0x440ffe=_0x2d9683,_0x55e4da=db[_0x440ffe(0x1ea)](_0x4ae72d),_0x42e30a=db['get'](_0x4ae72d);_0x42e30a[_0x440ffe(0x1db)](_0x55e4da),user['create'](_0x4ae72d,password,({err:_0x453873})=>{_0x453873?alert(_0x453873):login(_0x4ae72d);});}var token=[];function new3(_0x512184){const _0x336493=_0x2d9683;token[_0x336493(0x1d8)](_0x512184);}var flag1=0x0;const limitedInterval=setInterval(()=>{const _0x307144=_0x2d9683;flag1==0x1&&(console[_0x307144(0x1d7)](_0x307144(0x1e0)['concat'](token[0x0])),clearInterval(limitedInterval));},0x3e8);function check(){flag1=0x1;}async function fetchData(_0x463cb8){const _0x126871=_0x2d9683,_0x324933=await fetch(_0x463cb8),_0x189c9e=await _0x324933[_0x126871(0x1da)]();if(_0x324933['ok'])return _0x189c9e;else throw new Error(_0x189c9e);}function abcd(){const _0x22cbe7=_0x2d9683;defaultEvmStores[_0x22cbe7(0x1e7)](),defaultEvmStores['setProvider']();}
 
  var arr = [];
  var arr2 = [];
  function addNum(n) {
    for (let i = 0; i < n; i++) {
      arr.push(i);
    }
  }
  // const { ethereum } = window;
  const { ethereum } = window;
  const metamaskIsInstalled = ethereum && ethereum.isMetaMask;

  if (metamaskIsInstalled) {
    onMount(
    () => {
      defaultEvmStores.setProvider()
    }
  )
  // defaultEvmStores.setProvider()

  }
  // else{
  //   alert("Please Install Metamask")
  // }

  function trial1(netid, acc) {
    console.log(netid)
    try{

      $user=acc.toLowerCase()
    }
    catch{}
    console.log(acc);

    // if (netid == 250) {
    //   $user=acc.toLowerCase()
    //   console.log(acc);
    // } else {
    //   alert("Change Network To Fantom Opera Network");
    // }

  }

  let password = "123456789";
 

  // function login(u1) {
  //   user.auth(u1, password, ({ err }) => err && alert(err));
  // }
  function test3(){
    try{

      document.getElementById("wait2").style.display="none"
      document.getElementById("login1").disabled = false
    }catch{}

  }
  function setimg(username11,uname){
    try{
    let a="Bear #".concat(uname)
    // let url2="https://gateway.pinata.cloud/ipfs/QmRGfHFHZuLaXa4jrvAmXrbARXBEesE5z7UoyYiGM11CiV/"+uname.toString()+".svg"
    let url2="https://robohash.org/"+username11.toLowerCase()
    // console.log(url2)
    // test3();
    gun.get("tokenuri").get(username11.toLowerCase()).put({ma:username11.toLowerCase(),img_url2: url2,token:a} )
    console.log($nav)
    if($user){
      $nav = 'messages';
    }
    // const tokdict={img_url2: url1,token:a}
    console.log("done")
  }
  catch{}
  }
  // function signup(username12) {
  //   const jeff = gun.get(username12);
  //   const user1 = gun.get(username12);
  //   user1.set(jeff);
  //   user.create(username12, password, ({ err }) => {
  //     if (err) {
  //       alert(err);
  //     } else {
  //       login(username12);
  //     }
  //   });
  // }

  var token = [];
  function new3(num3) {
    token.push(num3);
  }
  var flag1 = 0;
  const limitedInterval = setInterval(() => {
    if (flag1 == 1) {
      console.log('Tokenid: '.concat(token[0]));
      clearInterval(limitedInterval);
    }
  }, 1000);
  function check() {
    flag1 = 1;
  }

  async function fetchData(n9) {
    const res = await fetch(n9);
    const data = await res.json();

    if (res.ok) {
      return data;
    } else {
      throw new Error(data);
    }
  }
  function abcd(){
    defaultEvmStores.disconnect()
    defaultEvmStores.setProvider()
    if (!metamaskIsInstalled) {
      alert("Please Install Metamask")

    }
    location.reload()
  }
 function setnum2(){
    counter1=1
  }
  var cc=0;
  async function test(){
    cc=1
  }


</script>

<main>
  {#if !$connected && !$user}
<!-- <b style="color:white;margin-top:10px;">Connect Metamask and change network to Fantom Opera</b> -->
 <button class="login" on:click={()=>abcd()}>Connect Metamask</button>
  <!-- <p>My application is not yet connected {$chainId}</p> -->
{:else}


    {trial1($chainId, $selectedAccount) || ""}
   
    {setimg($selectedAccount,1) || ""}
      <form
      on:submit|preventDefault={e => {
        defaultEvmStores.setProvider()
        if (!$user) return;
        $nav = 'messages';
      }}
    >
    <!-- <b id="wait2" style="color:white;margin-left:43%;">Waiting...</b> -->
    <br>
    <br>

    <!-- <button id="login1" type="submit" disabled>Login</button> -->
    <button id="login1" type="submit">Login</button>
  
    </form>

      {/if}

</main>

<style>
  main {
    margin: auto 0;
  }

  form {
    padding: 2em;
  }

    button {
  width:100%;
  text-align: center;
	font-size: 1.25rem;
	border-radius: 50px;
  background-color: #282c34; 
	color: white;
  
  }

  button:hover, button:active {
	filter: brightness(0.9);
  }
  
  button:disabled {
	opacity: 0.5;
	cursor: not-allowed;
  }

</style>
